// src/services/photoApi.ts
// Photo scan-to-fill: upload a photo, get back searchable equipment text.
// Uses the longRunningApi (5-min) instance — cellular image uploads are slow.
import { longRunningApi } from './api';

export interface PhotoExtractResult {
  text: string;
}

/**
 * Upload a photo to POST /api/photo/extract and return the extracted
 * equipment text (model / serial / error code). The backend discards the
 * image after extraction. Rejects on 4xx/5xx so the caller can toast a
 * clear message.
 */
export async function extractFromPhoto(file: File): Promise<PhotoExtractResult> {
  const form = new FormData();
  form.append('image', file);
  // longRunningApi defaults to Content-Type: application/json (api.ts). For a
  // multipart body axios must be told to use multipart so it writes a proper
  // boundary — same override voiceApi.ts uses. Without it the backend 422s.
  const response = await longRunningApi.post('/photo/extract', form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return { text: response.data.text };
}
